import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tr-block-template',
  templateUrl: './block-template.component.html',
  //styleUrls: ['./block-template.component.scss']
})
export class BlockTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/block-template/block-template.component.ts